import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import WarningAmber from "@mui/icons-material/WarningAmber";
import Fade from "@mui/material/Fade";
import { ThemeProvider, createTheme, useTheme } from "@mui/material/styles";
const ProcessingModal = ({ isOpen, onClose, processingModalMessage }) => {
  const outerTheme = useTheme();
  const localTheme = createTheme(outerTheme, {
    typography: {
      ...outerTheme.typography,
      fontFamily: "Lato, sans-serif",
    },
  });

  return (
    <ThemeProvider theme={localTheme}>
      <Modal
        open={isOpen}
        onClose={onClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
    >
      <Fade in={isOpen}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "calc(100% - 32px)",
          maxWidth: 440,
          bgcolor: "background.paper",
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.24)",
          p: 0,
          borderRadius: "8px",
          overflow: "hidden",
          border: "1px solid #fed7aa",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#9a3412",
            p: 2.5,
            background: "linear-gradient(135deg, #fff7ed 0%, #fffbeb 100%)",
            borderBottom: "1px solid #fed7aa",
          }}
        >
          <WarningAmber sx={{ fontSize: 30 }} />
          <Typography id="modal-title" variant="h6" component="h2" sx={{ fontWeight: 800 }}>
            Request In Progress
          </Typography>
        </Box>

        <Typography id="modal-description" sx={{ p: 2.5, color: "#475569" }}>
          {processingModalMessage ||
            "This request is currently being processed by another user."}
        </Typography>

        <Box sx={{ display: "flex", justifyContent: "flex-end", px: 2.5, pb: 2.5 }}>
          <Button
            onClick={onClose}
            variant="contained"
            sx={{
              bgcolor: "#d97706",
              borderRadius: "8px",
              px: 3,
              fontWeight: 700,
              textTransform: "none",
              "&:hover": {
                bgcolor: "#b45309",
              },
            }}
          >
            OK
          </Button>
        </Box>
      </Box>
      </Fade>
    </Modal>
    </ThemeProvider>
  );
};

export default ProcessingModal;
